<div class="text-size-18 word-break page-container">
  <h1 class="mb-3 mt-5 text-size-40 fw-700">Terms of Service</h1>
  <p class="text-size-18 my-2">Last Updated: February 11, 2025</p>
  <p class="text-size-18 my-2">
    Welcome! Thank you for your interest in our services. These Terms of Service ("Terms") govern your use of the websites, applications,
    and other marketing assets (collectively, "Services") offered by our clients. Please read these Terms carefully before engaging with any
    Services.
  </p>

  <h3 class="mb-2 mt-5 text-size-30 fw-700">Acceptance of Terms</h3>
  <p class="text-size-18 my-2">
    By accessing or using the Services, you agree to be bound by these Terms and all applicable laws and regulations. If you do not agree
    with any part of these Terms, you are prohibited from using or accessing the Services.
  </p>

  <h3 class="mb-2 mt-5 text-size-30 fw-700">Modification of Terms</h3>
  <p class="text-size-18 my-2">
    We reserve the right, at our sole discretion, to modify or replace these Terms at any time. We will provide notice of such changes by
    updating the date at the top of these Terms and, where appropriate, through other communications. Your continued use of the Services
    after any changes signifies your acceptance of our updated Terms.
  </p>

  <h3 class="mb-2 mt-5 text-size-30 fw-700">Access and Use of the Services</h3>
  <ul class="ul-disc">
    <li>
      <p class="text-size-18 my-2">
        Eligibility: You must be at least 18 years old to use the Services. By agreeing to these Terms, you represent that you are of legal
        age to form a binding contract with the respective client.
      </p>
    </li>

    <li>
      <p class="text-size-18 my-2">
        Your Account: If you create an account, you are responsible for maintaining the confidentiality of your account and password and for
        restricting access to your computer, and you agree to accept responsibility for all activities that occur under your account or
        password.
      </p>
    </li>

    <li>
      <p class="text-size-18 my-2">
        Account Security: You must provide accurate and complete information when creating an account. You are responsible for safeguarding
        your password and for all activities that occur under your account. Notify us immediately of any unauthorized use of your account.
      </p>
    </li>

    <li>
      <p class="text-size-18 my-2">
        Prohibited Uses: You may not use the Services for any unlawful purpose or in any manner inconsistent with these Terms, nor may you
        use the Services to collect sensitive information about others, including but not limited to credit card information, without proper
        consent.
      </p>
    </li>
  </ul>

  <h3 class="mb-2 mt-5 text-size-30 fw-700">Intellectual Property Rights</h3>
  <p class="text-size-18 my-2">
    The content, including text, graphics, images, and other material provided through the Services, is the proprietary property of the
    respective client or its licensors with all rights reserved. No content may be modified, copied, distributed, framed, reproduced,
    republished, downloaded, displayed, posted, transmitted, or sold in any form or by any means, in whole or in part, without the client's
    prior written permission.
  </p>

  <h3 class="mb-2 mt-5 text-size-30 fw-700">Third-Party Links</h3>
  <p class="text-size-18 my-2">
    The Services may include links to third-party websites or resources. These links are provided for your convenience only and do not imply
    an endorsement, warranty, guarantee, or recommendation by the clients. You acknowledge that the clients are not responsible for the
    availability of external sites or resources, and do not endorse and are not responsible or liable for any content, advertising,
    products, or other materials on or available from such sites or resources.
  </p>

  <h3 class="mb-2 mt-5 text-size-30 fw-700">Disclaimers</h3>
  <p class="text-size-18 my-2">
    The Services and all included content are provided on an "as is" basis without warranty of any kind, whether express or implied. The
    clients specifically disclaim any and all warranties and conditions of merchantability, fitness for a particular purpose, or
    non-infringement, and any warranties arising out of course of dealing or usage of trade.
  </p>

  <h3 class="mb-2 mt-5 text-size-30 fw-700">Limitation of Liability</h3>
  <p class="text-size-18 my-2">
    To the maximum extent permitted by law, the clients shall not be liable for any indirect, incidental, punitive, or consequential damages
    of any kind related to or arising out of your use of the Services, including but not limited to damages for loss of profits, goodwill,
    use, data, or other intangible losses, whether or not the clients have been informed of the possibility of such damage.
  </p>

  <h3 class="mb-2 mt-5 text-size-30 fw-700">Governing Law</h3>
  <p class="text-size-18 my-2">
    These Terms shall be governed by the laws of the United States, without regard to its conflict of laws rules. You agree that any legal
    action or proceeding between you and the clients will be brought exclusively in a federal or state court of competent jurisdiction
    sitting in the United States.
  </p>
  <p class="text-size-18 my-2">If you have any questions about these Terms, please contact us at support@hifello.com.</p>
</div>
